export default "__VITE_ASSET__Bcmrebqo__"